function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { ReactNode, FC, CSSProperties, Ref } from 'react';
import cn from 'classnames';
require("./Typography.css");
var styles = {
  "Root": "Typography-module-Root_2Xd",
  "p1Variant": "Typography-module-p1Variant_1ft",
  "p2Variant": "Typography-module-p2Variant_lwF",
  "p3Variant": "Typography-module-p3Variant_1yM",
  "p4Variant": "Typography-module-p4Variant_1rq",
  "defaultWeight": "Typography-module-defaultWeight_Ndf",
  "strongWeight": "Typography-module-strongWeight_3VQ"
};
export const TypographyVariants = {
  p1: 'p1',
  p2: 'p2',
  p3: 'p3',
  p4: 'p4'
};
export const TypographyWeights = {
  default: 'default',
  strong: 'strong'
};
export const Typography = ({
  children,
  tag,
  variant,
  weight = TypographyWeights.default,
  className,
  innerRef,
  controlRef,
  style,
  ...props
}) => {
  let Wrapper = tag || 'p';
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    style: style,
    className: cn(styles.Root, styles[`${variant}Variant`], styles[`${weight}Weight`], className),
    ref: innerRef || controlRef
  }, props), children);
};
if (process.env.NODE_ENV !== 'production') {
  Typography.displayName = 'Typography';
}